// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"272":"50e552f0","877":"14a8eae0"}[chunkId] + ".js";
};